import { Component } from '@angular/core';

@Component({
  selector: 'recrewt-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent {
  readonly currentYear = new Date().getFullYear();
}
